module.exports = __webpack_public_path__ + "static/media/generate-btn.f69519c5.svg";